var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointmentSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2,23V10h26v3h2V5c0-1.6542969-1.3457031-3-3-3h-4V0h-2v2H9V0H7v2H3C1.3457031,2,0,3.3457031,0,5v18 c0,1.6542969,1.3457031,3,3,3h9v-2H3C2.4482422,24,2,23.5517578,2,23z M2,5c0-0.5517578,0.4482422-1,1-1h4v2h2V4h12v2h2V4h4 c0.5517578,0,1,0.4482422,1,1v3H2V5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,14c-4.9628906,0-9,4.0371094-9,9s4.0371094,9,9,9s9-4.0371094,9-9S27.9628906,14,23,14z M23,30 c-3.859375,0-7-3.140625-7-7s3.140625-7,7-7s7,3.140625,7,7S26.859375,30,23,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,18h-2v4.3818359c0,0.7636719,0.4238281,1.4492188,1.1054688,1.7890625l3.4472656,1.7236328l0.8945312-1.7890625 L24,22.3818359V18z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentSmall);
export default __webpack_public_path__ + "static/media/appointment--small.ed91e009019f6f7693a0332113cbccff.svg";
export { ForwardRef as ReactComponent };